import deleteTraySolutionInstance from './deleteTraySolutionInstance';
import enableTraySolutionInstance from './enableTraySolutionInstance';
import fetchTray from './fetchTray';
import fetchTrayAvailableWorkflows from './fetchTrayAvailableWorkflows';
import fetchTraySolutionInstances from './fetchTraySolutionInstances';
import fetchTrayUserId from './fetchTrayUserId';
import fetchTrayUserToken from './fetchTrayUserToken';
import newTrayInstanceWizard from './newTrayInstanceWizard';
import renameTraySolutionInstance from './renameTraySolutionInstance';
import updateTrayInstanceWizard from './updateTrayInstanceWizard';

export default {
  ...fetchTrayUserId,
  ...fetchTrayUserToken,
  ...fetchTrayAvailableWorkflows,
  ...newTrayInstanceWizard,
  ...updateTrayInstanceWizard,
  ...enableTraySolutionInstance,
  ...fetchTraySolutionInstances,
  ...deleteTraySolutionInstance,
  ...renameTraySolutionInstance,
  ...fetchTray,
};
